<template>
  <el-dialog ref="dialog" title="提示"size="tiny">
    <span>确定要修改该项吗？</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="changeStatus">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import http from '../../../../assets/js/http'
  export default {
    props: {
      source: {
        type: Object,
        default() {
          return {
            list: {},
            url: '',
            ids: [],
            isMul: false
          }
        }
      }
    },
    data() {
      return {
      }
    },
    methods: {
      closeDialog() {
        this.$refs.dialog.close()
      },
      beforeChangeStatus() {
        this.$refs.dialog.open()
      },
      changeStatus() {
        if (!this.source.url) {
          _g.toastMsg(this, 'error', '操作失败')
          return
        }
        if (this.source.isMul) { // 批量删除
          let postData = {
            ids: this.source.ids
          }
          this.apiPut(this.source.url, '', postData).then((res) => {
            if (res.code == 200) {
              this.$emit('statusCallback', true, res)
            } else {
              this.$emit('statusCallback', false, res)
              _g.dealError(this, res)
            }
          })
        } else {
          this.apiPut(this.source.url, '').then((res) => {
            if (res.code == 200) {
              this.$emit('statusCallback', true, res)
            } else {
              this.$emit('statusCallback', false, res)
              _g.dealError(this, res)
            }
          })
        }
        this.closeDialog()
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// statusDeal.vue?1d841e14